export function receivedTerms(html) {
  return { type: "CIRA_RECEIVED_TERMS", payload: { html } };
}
